import { action, set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { alias } from '@ember/object/computed';

class EmployeeForm extends Component {
  @service store;

  @alias('args.selectedEmployee.assignedDesks') assignedDesks;

  get selectedDesks() {
    return this.assignedDesks || [];
  }

  get unassignedDesks() {
    const { desks } = this.args;
    return desks.filter((desk) => {
      const deskRecord = this.store.peekRecord('desk', desk.id);
      return deskRecord.assignedTo === null;
    });
  }

  get desksToDisplay() {
    return [...this.selectedDesks, ...this.unassignedDesks];
  }

  get employeeHasInsight() {
    const { selectedEmployee } = this.args;

    if (!selectedEmployee?.attendancePerformance) {
      return false;
    }

    if (!selectedEmployee.attendancePerformance?.onsiteMission?.mission) {
      const DEFAULT_ATTENDANCE = 3;
      return selectedEmployee.attendancePerformance.averageWeeklyAttendance >= DEFAULT_ATTENDANCE;
    }

    if (this.assignedDesks.length) {
      return (
        selectedEmployee.attendancePerformance.averageWeeklyAttendance <
        selectedEmployee.attendancePerformance.onsiteMission.mission
      );
    }

    if (!this.assignedDesks.length) {
      return (
        selectedEmployee.attendancePerformance.averageWeeklyAttendance >=
        selectedEmployee.attendancePerformance.onsiteMission.mission
      );
    }

    return false;
  }

  get employeeInsightText() {
    const { selectedEmployee } = this.args;
    if (!selectedEmployee.attendancePerformance) {
      return 'This employee comes in more than our recommended 3 day onsite attendance. Do you want to assign them a desk?';
    }

    const onsiteMission = selectedEmployee.attendancePerformance.onsiteMission.mission;
    if (this.assignedDesks.length) {
      return `This employee comes in less than the required ${onsiteMission} day onsite attendance.`;
    } else {
      return `This employee comes more than the required ${onsiteMission} day onsite attendance. Do you want to assign them a desk?`;
    }
  }

  @action
  onDeskSelected(selectedDesks) {
    const { updateEmployeeOverview, updateResourceOverview, selectedEmployee } = this.args;
    const unassignedDesks = selectedEmployee.assignedDesks.filter(
      (assignedDesk) => !selectedDesks.any((desk) => assignedDesk.id === desk.id)
    );

    unassignedDesks.forEach((unassignedDesk) => {
      const deskRecord = this.store.peekRecord('desk', unassignedDesk.id);
      if (deskRecord) {
        set(deskRecord, 'assignedTo', null);
        // find map feature associated with the desk
        const feature = this.store
          .peekAll('map-feature')
          .find((mapFeature) => mapFeature.externalId === unassignedDesk.id);
        updateResourceOverview('update', feature);
      }
    });

    selectedDesks.forEach((desk) => {
      const deskRecord = this.store.peekRecord('desk', desk.id);
      if (deskRecord) {
        set(deskRecord, 'assignedTo', selectedEmployee.email);
        // find map feature associated with the desk
        const feature = this.store.peekAll('map-feature').find((mapFeature) => mapFeature.externalId === desk.id);
        updateResourceOverview('update', feature);
      }
    });
    // set selected desks on gql employee
    set(selectedEmployee, 'assignedDesks', selectedDesks);

    if (selectedDesks.length) {
      updateEmployeeOverview(selectedEmployee.id, selectedDesks);
    } else {
      updateEmployeeOverview(selectedEmployee.id, selectedDesks);
    }
  }
}

export default EmployeeForm;
